(ns ycweb.app.website.dlp.widgets.timebasedpromopanel
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cards :as cards]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.dlp.widgets.timebasedspecial :as tbs]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]))

(rum/defc countdown-timer < rum/reactive
  {:did-mount
   (fn [state]
     (tbs/start-countdown-timer state "time-based-promo-panel")
     state)}
  [app-atom {:keys [properties]}]
  (let [process-atom (cmn/process-cursor app-atom)
        {:keys [done? days hours minutes seconds]} (cmn/curact process-atom :countdown-timer)
        {:time-based-promo-panel/keys [time-expired?]} properties]
    [:<>
     [:div
      (if
        (or time-expired? done?)
        "Sorry, time's up!"
        "Time remaining:")]
     [:div.ttt-card__timer
      [:span.ttt-card__type
       {:data-ttt "days"}
       days]
      [:span.ttt-card__divider ":"]
      [:span.ttt-card__type
       {:data-ttt "hrs"}
       hours]
      [:span.ttt-card__divider ":"]
      [:span.ttt-card__type
       {:data-ttt "min"}
       minutes]
      [:span.ttt-card__divider ":"]
      [:span.ttt-card__type
       {:data-ttt "sec"}
       seconds]]]))

(rum/defc time-based-promo-panel < rum/reactive [app-atom _ {:keys [properties] :as component}]
  (let [{:time-based-promo-panel/keys
         [show-content? picture-public-id image-alt time-expired? products
          background-colour custom-viewmore-link custom-viewmore-text
          use-date-range? spacer spacer-size underline mute-widget?]} properties

        {:banner-background-colour/keys
         [colour-name text-dark]} background-colour

        cloudinary-str "https://res.cloudinary.com/yuppiechef/image/upload/"]

    (when
      (and
        (not mute-widget?)
        show-content?
        (u/presence products))
      [:<>
       [:div.yc-section
        [:div
         {:class (u/bem :flex-grid-group [:t-align-left :ml-align-center])}
         [:div
          {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-4])}
          [:a.flex-grid-content.card.ttt-card
           {:href (if (u/presence custom-viewmore-link) custom-viewmore-link "/tick-tick-tuesday.htm")
            :class
            [(if colour-name (str "u-bg-" colour-name) "u-bg-red")
             (if text-dark "u-text-oil" "u-text-white")]}
           [:article.ttt-card__content
            [:div.ttt-card__icon
             [:img.simple-image.yc-simple-image--full
              {:src
               (if (:background-colour/text-dark? background-colour)
                 (str cloudinary-str "v1700132504/ui-resources/shared/stickers/tick-tick-tuesday-icon-dark.svg")
                 (str cloudinary-str "v1700132505/ui-resources/shared/stickers/tick-tick-tuesday-icon-light.svg"))
               :alt "Tick Tick Tuesday Icon"}]]

            [:div.ttt-card__logotype
             (cond
               (u/presence picture-public-id)
               (web-common/lazy-image app-atom
                 picture-public-id
                 {:class ["simple-image  yc-simple-image--full"]}
                 {:q "auto"
                  :alt (if (u/presence image-alt) image-alt "Limited time promotion")})

               :else
               [:img.simple-image
                {:src (str cloudinary-str "v1582527344/ui-resources/shared/stickers/tick-tick-tuesday-logotype.svg")
                 :alt "Tick Tick Tuesday"
                 :class (u/bem :yc-simple-image [:full])}])]

            [:div.ttt-card__timer-wrapper
             (countdown-timer app-atom component)]]]]

         (map
           (fn [item]
             [:div
              {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-4])}
              (cards/product-card-default app-atom item {})])
           (if (> (count products) 3) (take 2 products) products))

         (when (> (count products) 3)
           [:div
            {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-4])}
            [:a.flex-grid-content.card.more-card
             {:href (if custom-viewmore-link custom-viewmore-link "/tick-tick-tuesday.htm")}
             [:div.more-card__content
              [:div.more-card__text
               (cond
                 (u/presence custom-viewmore-text)
                 [:span
                  {:dangerouslySetInnerHTML
                   {:__html custom-viewmore-text}}]

                 :else
                 (list
                   [:b "More"]
                   [:span " Tuesday Deals"]))
               [:div.more-card__arrow
                [:i {:class (u/bem :icon [:arrow-right :inline :medium-large])}]]]]]])]]

       (when (and use-date-range? (u/presence spacer))
         [:div
          {:class
           (u/bem :dlp-spacer
             [(if (= spacer-size "medium")
                (str "medium" underline)
                (str "standard" underline))])}])])))
